import {COMMON_BUILDING_TOKENS, TOKENS} from '../constants/tokens';

/**
 * Клубы пыли при размещении жетона: тяжелый объект упал на песочно-пыльную
 * дорогу. Пыль поднимается по всей площади ячейки, РЕЗКО расходится наружу и
 * затухает — без кружения и завихрений.
 *
 * Тайминги подогнаны под звук постройки (public/sounds/build_*.mp3, 1.4-2.9 с:
 * удар в начале, дальше отзвук): разлет укладывается в первые 200 мс, а
 * оседает пыль к 700-900 мс — пока звук еще звучит.
 *
 * Вся случайность живет в utils/effects/buildBuildingDustBurst, здесь — только
 * диапазоны и ассеты.
 */

// Ключи должны совпадать с загрузкой текстур в GameScene.preload()
export const BUILDING_DUST_TEXTURES = [
  {key: 'dust_1', path: '/img/effects/dust/dust_1.png'},
  {key: 'dust_2', path: '/img/effects/dust/dust_2.png'},
  {key: 'dust_3', path: '/img/effects/dust/dust_3.png'},
  {key: 'dust_4', path: '/img/effects/dust/dust_4.png'},
];

// Средняя сторона текстур (226-246 px): размеры считаются от размера ячейки,
// поэтому на поле с другим hexSize эффект не разъедется
export const DUST_TEXTURE_SIZE = 236;

export const BUILDING_DUST = {
  // Клубов в залпе: пыль поднимается по всей площади ячейки, поэтому их нужно
  // заметно больше, чем при выбросе из одной точки
  puffCount: {min: 30, max: 40},
  // Удар приходится на всю площадь постройки, а не в одну точку: клубы
  // рождаются по всему гексу. Доля от размера ячейки, радиус берется с
  // корнем — иначе точки сбиваются к центру и площадь не читается
  spawnRadiusFactor: 1,
  // Куда клуб уходит от ЦЕНТРА ячейки: рожденный у края пролетает меньше,
  // рожденный в середине — больше, и залп расходится общей волной. Разброс
  // широкий намеренно: на узком все клубы уходили на один радиус и в середине
  // залпа появлялась дыра
  endRadiusFactor: {min: 0.55, max: 1.8},
  // Ближний край волны: даже клуб у самой кромки обязан сдвинуться наружу
  minDriftFactor: 0.18,
  // Небольшой подъем: пыль стелется по земле, а не бьет фонтаном
  liftFactor: {min: 0.05, max: 0.18},
  // Сплющивание по вертикали: пыль лежит на земле, а не висит шаром
  groundSquash: 0.9,
  // Разброс угла — доля своего сектора. Считается от числа клубов: на
  // фиксированных градусах частый веер сбивался в комки и оставлял дыры
  angleJitterShare: 0.45,
  // Клубы стартуют компактными и разрастаются на лету: крупный старт слипается
  // в одно пятно и разлет становится не виден
  startScaleFactor: {min: 0.24, max: 0.4},
  endScaleFactor: {min: 0.5, max: 0.85},
  // Стартовая прозрачность: текстуры мягкие, поэтому берем почти полную —
  // иначе на подложке поля клубы теряются
  peakAlpha: {min: 0.9, max: 1},
  baseOffsetYFactor: 0.04,
  // Длительность под звук постройки: удар слышен сразу, отзвук тянется дальше
  duration: {min: 520, max: 780},
  // Залп единый: вся площадь бьет по земле разом
  delay: {min: 0, max: 50},
  // Больше одновременных залпов не держим: применение плана строительства
  // ставит пачку жетонов подряд, а клубов в каждом залпе десятки
  maxLiveBursts: 4,
};

// Насколько тяжелым выглядит падение конкретного жетона: дорога почти не
// поднимает пыли, центральный квартал и горы бьют по земле всерьез
export const DUST_INTENSITY_BY_TOKEN = {
  [COMMON_BUILDING_TOKENS.ROAD]: 0.75,
  [TOKENS.MOUNTAIN]: 1.3,
};

// Тон пыли: текстуры нейтрально-серые и рядом с теплой подложкой читаются как
// дым, а не как пыль. Умножением на этот цвет (setTint) они становятся
// песочными. Одна константа на все поля — при желании можно раздать тона по
// подложкам (configs/groundBackgrounds)
export const BUILDING_DUST_TINT = 0xD6C4A6;

export const DUST_INTENSITY_DEFAULT = 1;
export const DUST_INTENSITY_CENTRAL_QUARTER = 1.8;
export const DUST_INTENSITY_SPECIAL_BUILDING = 1.45;
